import DS, { ModelSchema } from 'ember-data';
import { ActiveModelSerializer } from 'active-model-adapter';
import { ModelRegistry } from 'ember-data/model';

const { EmbeddedRecordsMixin } = DS;

export default class RelationshipSerializer extends ActiveModelSerializer.extend(EmbeddedRecordsMixin, {
  isNewSerializerAPI: true,
}) {
  // Temporary: need this while API has not received updates to include all IDs (subject to change in Objects V3 - when Relationships API will be tweaked more)
  normalize(modelClass: ModelSchema<keyof ModelRegistry>, hash: Record<string, any>, prop?: string) {
    let customerId = hash.entity1_type === 'customer' ? hash.entity1_id : hash.entity2_id;
    let objectId = hash.entity1_type === 'object' ? hash.entity1_id : hash.entity2_id;

    hash.id = `${customerId}_${objectId}`;
    hash.customer_id = customerId;
    hash.object_id = objectId;

    return super.normalize(modelClass, hash, prop);
  }
}
